
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhatsAppIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-59.6%",
  y: "-59.6%",
  width: "219.7%",
  height: "219.7%",
  filterUnits: "objectBoundingBox",
  id: "whats-app-icon_8bf11a43a32422ef__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-10.2%",
  y: "-10.2%",
  width: "120.3%",
  height: "120.3%",
  filterUnits: "objectBoundingBox",
  id: "whats-app-icon_8bf11a43a32422ef__b"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.808,
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "48.982%",
  y1: "6.388%",
  x2: "49.489%",
  y2: "91.093%",
  id: "whats-app-icon_8bf11a43a32422ef__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#57D163",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#23B33A",
  offset: "100%"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#whats-app-icon_8bf11a43a32422ef__a)",
  transform: "translate(12 12)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6.716 20.213.362.213a9.9 9.9 0 0 0 5.03 1.37h.003c5.446 0 9.879-4.411 9.881-9.834a9.752 9.752 0 0 0-2.891-6.958 9.839 9.839 0 0 0-6.986-2.884c-5.451 0-9.884 4.412-9.886 9.834a9.778 9.778 0 0 0 1.51 5.234l.236.372-.998 3.629 3.74-.976zM.122 24l1.687-6.131a11.77 11.77 0 0 1-1.587-5.916C.225 5.43 5.558.122 12.11.122a11.843 11.843 0 0 1 8.41 3.47 11.732 11.732 0 0 1 3.48 8.37c-.003 6.524-5.337 11.833-11.89 11.833h-.004c-1.99 0-3.945-.498-5.682-1.44L.122 24z",
  fill: "#B3B3B3",
  fillRule: "nonzero",
  filter: "url(#whats-app-icon_8bf11a43a32422ef__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 23.878 1.687-6.13A11.77 11.77 0 0 1 .1 11.831C.103 5.308 5.436 0 11.989 0a11.843 11.843 0 0 1 8.41 3.47 11.732 11.732 0 0 1 3.479 8.371c-.003 6.524-5.337 11.832-11.89 11.832h-.004c-1.99 0-3.945-.497-5.682-1.44L0 23.878z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.993 1.999c-5.451 0-9.884 4.411-9.886 9.834a9.778 9.778 0 0 0 1.51 5.233l.236.372-.999 3.63 3.74-.977.362.213a9.902 9.902 0 0 0 5.03 1.371h.003c5.446 0 9.88-4.412 9.881-9.834a9.75 9.75 0 0 0-2.891-6.958 9.839 9.839 0 0 0-6.986-2.884z",
  fill: "#000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.993 1.999c-5.451 0-9.884 4.411-9.886 9.834a9.778 9.778 0 0 0 1.51 5.233l.236.372-.999 3.63 3.74-.977.362.213a9.902 9.902 0 0 0 5.03 1.371h.003c5.446 0 9.88-4.412 9.881-9.835a9.75 9.75 0 0 0-2.891-6.957 9.839 9.839 0 0 0-6.986-2.884z",
  fill: "url(#whats-app-icon_8bf11a43a32422ef__c)",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.017 6.885c-.222-.492-.457-.502-.668-.51l-.57-.008c-.198 0-.52.074-.792.37s-1.04 1.012-1.04 2.467 1.065 2.86 1.214 3.058c.148.198 2.055 3.279 5.074 4.464 2.51.986 3.02.79 3.565.74.545-.049 1.757-.715 2.005-1.406.247-.69.247-1.282.173-1.406-.074-.123-.272-.197-.57-.345-.297-.148-1.757-.863-2.03-.962-.272-.099-.47-.148-.668.148-.198.296-.767.962-.94 1.16-.173.197-.346.222-.644.074-.297-.148-1.254-.46-2.389-1.468-.883-.784-1.479-1.752-1.652-2.048-.174-.296-.019-.456.13-.603.134-.133.297-.346.446-.518.149-.173.198-.296.297-.493.099-.197.05-.37-.025-.518-.074-.148-.652-1.61-.916-2.196",
  fill: "#FFF"
}))));

      const __svgRaw = "<svg width=\"48\" height=\"48\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <defs>\r\n        <filter x=\"-59.6%\" y=\"-59.6%\" width=\"219.7%\" height=\"219.7%\" filterUnits=\"objectBoundingBox\" id=\"ewu1lessja\">\r\n            <feOffset dy=\"2\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur stdDeviation=\"2\" in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0\" in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n        <filter x=\"-10.2%\" y=\"-10.2%\" width=\"120.3%\" height=\"120.3%\" filterUnits=\"objectBoundingBox\" id=\"b9kme2wpmb\">\r\n            <feGaussianBlur stdDeviation=\".808\" in=\"SourceGraphic\"/>\r\n        </filter>\r\n        <linearGradient x1=\"48.982%\" y1=\"6.388%\" x2=\"49.489%\" y2=\"91.093%\" id=\"25lqh6hrjc\">\r\n            <stop stop-color=\"#57D163\" offset=\"0%\"/>\r\n            <stop stop-color=\"#23B33A\" offset=\"100%\"/>\r\n        </linearGradient>\r\n    </defs>\r\n    <g filter=\"url(#ewu1lessja)\" transform=\"translate(12 12)\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"m6.716 20.213.362.213a9.9 9.9 0 0 0 5.03 1.37h.003c5.446 0 9.879-4.411 9.881-9.834a9.752 9.752 0 0 0-2.891-6.958 9.839 9.839 0 0 0-6.986-2.884c-5.451 0-9.884 4.412-9.886 9.834a9.778 9.778 0 0 0 1.51 5.234l.236.372-.998 3.629 3.74-.976zM.122 24l1.687-6.131a11.77 11.77 0 0 1-1.587-5.916C.225 5.43 5.558.122 12.11.122a11.843 11.843 0 0 1 8.41 3.47A11.732 11.732 0 0 1 24 11.962c-.003 6.524-5.337 11.833-11.89 11.833h-.004c-1.99 0-3.945-.498-5.682-1.44L.122 24z\" fill=\"#B3B3B3\" fill-rule=\"nonzero\" filter=\"url(#b9kme2wpmb)\"/>\r\n        <path d=\"m0 23.878 1.687-6.13A11.77 11.77 0 0 1 .1 11.831C.103 5.308 5.436 0 11.989 0a11.843 11.843 0 0 1 8.41 3.47 11.732 11.732 0 0 1 3.479 8.371c-.003 6.524-5.337 11.832-11.89 11.832h-.004c-1.99 0-3.945-.497-5.682-1.44L0 23.878z\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\r\n        <path d=\"M11.993 1.999c-5.451 0-9.884 4.411-9.886 9.834a9.778 9.778 0 0 0 1.51 5.233l.236.372-.999 3.63 3.74-.977.362.213a9.902 9.902 0 0 0 5.03 1.371h.003c5.446 0 9.88-4.412 9.881-9.834a9.75 9.75 0 0 0-2.891-6.958 9.839 9.839 0 0 0-6.986-2.884z\" fill=\"#000\" fill-rule=\"nonzero\"/>\r\n        <path d=\"M11.993 1.999c-5.451 0-9.884 4.411-9.886 9.834a9.778 9.778 0 0 0 1.51 5.233l.236.372-.999 3.63 3.74-.977.362.213a9.902 9.902 0 0 0 5.03 1.371h.003c5.446 0 9.88-4.412 9.881-9.835a9.75 9.75 0 0 0-2.891-6.957 9.839 9.839 0 0 0-6.986-2.884z\" fill=\"url(#25lqh6hrjc)\" fill-rule=\"nonzero\"/>\r\n        <path d=\"M9.017 6.885c-.222-.492-.457-.502-.668-.51l-.57-.008c-.198 0-.52.074-.792.37s-1.04 1.012-1.04 2.467 1.065 2.86 1.214 3.058c.148.198 2.055 3.279 5.074 4.464 2.51.986 3.02.79 3.565.74.545-.049 1.757-.715 2.005-1.406.247-.69.247-1.282.173-1.406-.074-.123-.272-.197-.57-.345-.297-.148-1.757-.863-2.03-.962-.272-.099-.47-.148-.668.148-.198.296-.767.962-.94 1.16-.173.197-.346.222-.644.074-.297-.148-1.254-.46-2.389-1.468-.883-.784-1.479-1.752-1.652-2.048-.174-.296-.019-.456.13-.603.134-.133.297-.346.446-.518.149-.173.198-.296.297-.493.099-.197.05-.37-.025-.518-.074-.148-.652-1.61-.916-2.196\" fill=\"#FFF\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/whats-app-icon.8bf11a43a32422ef6e6ccafb28e61679.svg"),
        {
          React: SvgWhatsAppIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      